// Color relay: syncs custom color swatches with native variant selects
(function () {
  function initColorRelay() {
    var items = document.querySelectorAll('.product-custom-layout__color-item[data-color-relay]');
    if (!items.length) return;
    var variantSelects = document.querySelector('product-variant-selects');
    if (!variantSelects) return;

    items.forEach(function (item) {
      item.addEventListener('click', function () {
        var value = item.dataset.colorRelay;
        // Update is-selected immediately on click
        items.forEach(function (ci) {
          ci.classList.toggle('is-selected', ci === item);
        });
        var nameEl = document.querySelector('[data-selected-color-name]');
        if (nameEl) nameEl.textContent = value;
        // Sync native variant radio
        var colorFieldset = variantSelects.querySelector('.product-form__input--color-option');
        if (!colorFieldset) return;
        var radio = Array.from(colorFieldset.querySelectorAll('input[type="radio"]')).find(function (r) {
          return r.value === value;
        });
        if (!radio || radio.checked) return;
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      });
      item.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); item.click(); }
      });
    });

    // Sync is-selected when variant changes (e.g. URL param or other trigger)
    variantSelects.addEventListener('change', function (e) {
      var colorFieldset = variantSelects.querySelector('.product-form__input--color-option');
      if (!colorFieldset || !colorFieldset.contains(e.target)) return;
      var selectedValue = e.target.value;
      items.forEach(function (ci) {
        ci.classList.toggle('is-selected', ci.dataset.colorRelay === selectedValue);
      });
      var nameEl = document.querySelector('[data-selected-color-name]');
      if (nameEl) nameEl.textContent = selectedValue;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initColorRelay);
  } else {
    initColorRelay();
  }
})();

// Sticky cart: shows/hides the sticky bar based on buy button visibility
(function () {
  var observerTarget = document.querySelector('.product-form__buttons');
  if (!observerTarget) return;

  var lastScrollY = window.scrollY;
  var isScrollingDown = true;

  var callback = function (entries) {
    entries.forEach(function (entry) {
      var currentScrollY = window.scrollY;
      isScrollingDown = currentScrollY > lastScrollY;
      lastScrollY = currentScrollY;

      var stickyCart = document.querySelector('.product__sticky-cart');
      if (!stickyCart) return;

      /* shopify design mode is causing the sticky cart to show when it shouldn't */
      if (isScrollingDown) {
        if (!entry.isIntersecting && !DeviceDetector.isMobile() && !Shopify.designMode) {
          stickyCart.classList.remove('is-hidden');
        } else if (!entry.isIntersecting && DeviceDetector.isMobile() && window.scrollY > window.innerHeight && !Shopify.designMode) {
          stickyCart.classList.remove('is-hidden');
        } else {
          stickyCart.classList.add('is-hidden');
        }
      } else {
        if (entry.isIntersecting) {
          stickyCart.classList.add('is-hidden');
        }
      }
    });
  };

  var observer = new IntersectionObserver(callback, { threshold: 0.8 });

  function initStickyCart() {
    observer.observe(observerTarget);
  }

  document.addEventListener('DOMContentLoaded', initStickyCart);

  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', initStickyCart);
    document.addEventListener('shopify:section:unload', function () {
      observer.unobserve(observerTarget);
    });
  }
})();

// pcl-bounce: sube (sin 0→π/2), pausa 0.25s en el pico, baja (sin π/2→π)
// La derivada del seno en π/2 es 0 → entrada y salida de la pausa sin brusquedad
(function () {
  var RISE_MS   = 500;   // subida
  var HOLD_MS   = 250;   // pausa arriba
  var FALL_MS   = 500;   // bajada
  var DISTANCE  = 75;    // px hacia arriba
  var DELAY_MS  = 3000;

  function runBounce(el) {
    var phase = 'rise';
    var start = null;

    function step(ts) {
      if (!start) start = ts;
      var elapsed = ts - start;

      if (phase === 'rise') {
        var t = Math.min(elapsed / RISE_MS, 1);
        el.style.marginTop = '-' + (Math.sin(t * Math.PI / 2) * DISTANCE) + 'px';
        if (t < 1) { requestAnimationFrame(step); return; }
        phase = 'hold';
        start = ts;
        requestAnimationFrame(step);

      } else if (phase === 'hold') {
        el.style.marginTop = '-' + DISTANCE + 'px';
        if (elapsed < HOLD_MS) { requestAnimationFrame(step); return; }
        phase = 'fall';
        start = ts;
        requestAnimationFrame(step);

      } else {
        var t = Math.min(elapsed / FALL_MS, 1);
        el.style.marginTop = '-' + (Math.cos(t * Math.PI / 2) * DISTANCE) + 'px';
        if (t < 1) { requestAnimationFrame(step); } else { el.style.marginTop = ''; }
      }
    }

    requestAnimationFrame(step);
  }

  function init() {
    if (window.innerWidth >= 1024) return;
    var el = document.querySelector('.product-custom-layout');
    if (!el) return;
    setTimeout(function () { runBounce(el); }, DELAY_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', init);
  }
})();

// ── Selector de talla: mensajes de estado y validación add to cart ─────────
(function () {
  'use strict';

  function init() {
    var tallaWrapper = document.querySelector('.pcl-wrapper-tallas');
    if (!tallaWrapper) return;

    var fitNote    = tallaWrapper.querySelector('[id^="pcl-fit-note-"]');
    var lowStockMsg = tallaWrapper.querySelector('[id^="pcl-low-stock-message-"]');
    var sizeMsg    = tallaWrapper.querySelector('[id^="pcl-size-message-"]');
    var variantsEl = tallaWrapper.querySelector('.product-custom-layout__variants');
    if (!variantsEl || !sizeMsg) return;

    // El usuario aún no ha elegido una talla explícitamente
    var userSelectedSize = false;

    // Ocultar visualmente el borde de la talla preseleccionada por Shopify
    tallaWrapper.classList.add('pcl-no-preselect');
    var soldOutMessage = tallaWrapper.dataset.soldOutMessage || '';
    var selectSizeMessage = tallaWrapper.dataset.selectSizeMessage || '';

    // ── Helpers ───────────────────────────────────────────────────────────
    function showFitNote() {
      sizeMsg.hidden = true;
      sizeMsg.textContent = '';
      sizeMsg.classList.remove('product-custom-layout__size-message--error');
      if (fitNote) fitNote.hidden = false;
    }

    function updateLowStockMessage(label) {
      if (!lowStockMsg) return;
      lowStockMsg.hidden = !label.querySelector('.product-option__low-stock-dot');
    }

    function showMessage(text, isError) {
      if (fitNote) fitNote.hidden = true;
      if (lowStockMsg) lowStockMsg.hidden = true;
      sizeMsg.textContent = text;
      sizeMsg.classList.toggle('product-custom-layout__size-message--error', !!isError);
      sizeMsg.hidden = false;
    }

    // ── Clicks en las tallas (delegado en variantsEl, sobrevive al AJAX) ──
    variantsEl.addEventListener('click', function (e) {
      var label = e.target.closest('label.product-option__label');
      if (!label) return;

      var input = variantsEl.querySelector('input#' + CSS.escape(label.htmlFor));
      if (!input) return;

      if (input.disabled || input.classList.contains('disabled')) {
        // Deseleccionar la talla que hubiera elegida
        variantsEl.querySelectorAll('fieldset:not(.product-form__input--color-option) input[type="radio"]')
          .forEach(function (r) { r.checked = false; });
        input.checked = true;
        userSelectedSize = false;
        tallaWrapper.classList.remove('pcl-no-preselect');
        var productForm = submitBtn.closest('product-form');
        var selectedColor = variantsEl.querySelector('.product-form__input--color-option input[type="radio"]:checked');
        productForm?.setNotifyState(true, input.value, selectedColor ? selectedColor.value : '');
        showMessage(soldOutMessage, false);
      } else {
        userSelectedSize = true;
        tallaWrapper.classList.remove('pcl-no-preselect');
        updateLowStockMessage(label);
        showFitNote();
      }
    });

    // ── Interceptar Add to cart: el usuario debe haber elegido talla ──────
    var submitBtn = document.querySelector('[id^="ProductSubmitButton-"]');
    if (!submitBtn) return;

    submitBtn.addEventListener('click', function (e) {
      if (!userSelectedSize) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showMessage(selectSizeMessage, true);
      }
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', init);
  }
})();

// Delivery estimate based on configurable business-day offsets.
(function () {
  'use strict';

  function addBusinessDays(startDate, businessDays) {
    var date = new Date(startDate);
    var daysAdded = 0;

    while (daysAdded < businessDays) {
      date.setDate(date.getDate() + 1);
      if (date.getDay() !== 0 && date.getDay() !== 6) daysAdded += 1;
    }

    return date;
  }

  function addCalendarDays(startDate, days) {
    var date = new Date(startDate);
    date.setDate(date.getDate() + days);
    return date;
  }

  function initDeliveryEstimates() {
    document.querySelectorAll('[data-delivery-estimate]').forEach(function (element) {
      var minDays = Math.max(1, parseInt(element.dataset.minBusinessDays, 10) || 1);
      var maxDays = Math.max(minDays, parseInt(element.dataset.maxBusinessDays, 10) || minDays);
      var locale = element.dataset.locale || document.documentElement.lang || 'es';
      var template = element.dataset.template || '';
      var tomorrowLabel = element.dataset.tomorrowLabel || '';
      var dateTemplate = element.dataset.dateTemplate || '[date]';
      var today = new Date();
      var tomorrow = new Date(today);
      var addDays = element.dataset.excludeWeekends === 'false'
        ? addCalendarDays
        : addBusinessDays;
      var minDeliveryDate = addDays(today, minDays);
      var maxDeliveryDate = addDays(today, maxDays);
      tomorrow.setDate(tomorrow.getDate() + 1);
      var isSameMonth = minDeliveryDate.getFullYear() === maxDeliveryDate.getFullYear()
        && minDeliveryDate.getMonth() === maxDeliveryDate.getMonth();

      var formatDate = function (date, includeMonth) {
        if (/\[(weekday|day)\]/.test(dateTemplate)) {
          var part = function (options) { return new Intl.DateTimeFormat(locale, options).format(date); };
          return dateTemplate
            .replace('[weekday]', part({ weekday: 'long' }))
            .replace('[day]', part({ day: 'numeric' }))
            .replace(/\s*\[month\]/, includeMonth ? ' ' + part({ month: 'long' }) : '');
        }
        var formatOptions = {
          weekday: 'long',
          day: 'numeric'
        };
        if (includeMonth) formatOptions.month = 'long';
        var formatter = new Intl.DateTimeFormat(locale, formatOptions);
        return dateTemplate.replace('[date]', formatter.format(date).replace(/,/g, ''));
      };
      var isTomorrow = minDeliveryDate.getFullYear() === tomorrow.getFullYear()
        && minDeliveryDate.getMonth() === tomorrow.getMonth()
        && minDeliveryDate.getDate() === tomorrow.getDate();
      var minDate = isTomorrow ? tomorrowLabel : formatDate(minDeliveryDate, !isSameMonth);
      var maxDate = formatDate(maxDeliveryDate, !isSameMonth);

      element.textContent = template.replace('[min]', minDate).replace('[max]', maxDate);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDeliveryEstimates);
  } else {
    initDeliveryEstimates();
  }

  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', initDeliveryEstimates);
  }
})();
